import { Dialog } from "primereact/dialog";
import './UpdateModal.scss';
import { Button, DatePicker, Input } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getClientEntryChannels, saveProspectClients } from "../../../api";
import CreatableSelect from 'react-select/creatable';
import { toast } from "react-toastify";
import moment from "moment";
import Select from 'react-select';
import { CLIENT_GROUP_CRM_FILTER } from "../../../config";
import { LoadingIcon } from "../../common/Icons";
import classNames from "classnames";

export default function UpdateModal({
  isOpen,
  setIsOpen,
  emailData,
  clientData
}) {
  const { token, navCommunity } = useSelector((state) => state.auth);
  const [channelOptions, setChannelOptions] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    firstName: null,
    lastName: null,
    group: null,
    email: null,
    phoneNumber: null,
    clientErpId: null,
    revenue: null,
    observation: null,
    dueDate: null,
    channel: null,
  });
  const [formErrors, setFormErrors] = useState([]);

  const resetForm = () => {
    setFormData({
      firstName: null,
      lastName: null,
      group: null,
      email: null,
      phoneNumber: null,
      clientErpId: null,
      revenue: null,
      observation: null,
      dueDate: null,
      channel: null,
    });
  };

  let getClientEntryChannelsQuery = useQuery(
    ["getClientEntryChannels", token, navCommunity],
    async () => {
      if (token && navCommunity) {
        try {
          const response = await getClientEntryChannels({
            token,
            organizationId: navCommunity.id
          });

          const data = response.data.data
            .map(it => ({
              value: it.id,
              label: it.label
            }));

          setChannelOptions(data);

          if (data.length > 0) {
            if (emailData) {
              const emailChannel = data.find(it => it.label === 'Mail');

              if (emailChannel) {
                setFormData(prevState => ({
                  ...prevState,
                  channel: emailChannel
                }));
              }
            } else {
              setFormData(prevState => ({
                ...prevState,
                channel: data[0]
              }));
            }
          }

        } catch (e) {
          console.error("Error while fetching canals", {e})
        }
      }
    }
  );

  useEffect(() => {
    if (clientData) {
      setFormData({
        id: clientData?.id,
        lastName: clientData?.lastName,
        firstName: clientData?.firstName,
        group: clientData?.group ? CLIENT_GROUP_CRM_FILTER.find(it => it.value === clientData.group) : null,
        email: clientData?.email,
        phoneNumber: clientData?.phoneNumber,
        clientErpId: clientData?.clientErpId,
        revenue: clientData?.revenue,
        observation: clientData?.observation,
        dueDate: clientData?.dueDate ? moment(clientData.dueDate) : null,
        channel: clientData?.channel ? { value: clientData.channel.id, label: clientData.channel.label } : null,
      });
    }
  }, [clientData, channelOptions]);

  const handleSave = () => {
    const errors = getValidationErrors();
    if (errors.length !== 0) {
      setFormErrors(errors);
      return;
    }

    setIsSaving(true);

    const dataToSave = {...formData };
    if (emailData) {
      dataToSave.attachmentId = emailData?.id;
    }

    saveProspectClients({token, organizationId: navCommunity.id, items: [dataToSave]})
    .then((res) => {
      if (res.status === 200) {
        toast.success("Les données ont été enregistrées avec succès");
        setIsOpen(false);
      } else {
        toast.error("Une erreur est survenue lors de l'enregistrement des données");
      }
    }).catch(e => {
      toast.error("Une erreur est survenue lors de l'enregistrement des données");
      console.error("Error saving data : ", e);
    }).finally(() => {
      setIsSaving(false);
    });
  };

  const getValidationErrors = () => {
    const errors = [];

    if (!formData.lastName) {
      errors.push("lastName");
    }
    if (!formData.channel) {
      errors.push("channel");
    }

    return errors;
  };

  function replaceWithBr(text) {
    return text.replace(/\n/g, "<br />")
  }

  return (
    <Dialog
      visible={isOpen}
      style={{ width: emailData != null ? '1200px' : '512px', height: '660px' }}
      resizable={true}
      className="prospect_client_modal"
      showHeader={false}
    >
      {emailData != null && (
        <div className="section email_section">
          <h5 className="section_title">Email Contenu</h5>
          <p className="email_from"><span>De</span>: {emailData.senderEmail}</p>
          <p className="email_to"><span>À</span>: {emailData.recipientEmail}</p>
          <div className="email_text">
            <p className="subject">{emailData.subject}</p>
            <div dangerouslySetInnerHTML={{__html: replaceWithBr(emailData.body)}} />
          </div>
        </div>
      )}

      {emailData != null && (<div className="vertical_divider" />)}

      <div className="section form_section">
        <h5 className="section_title">Détails clients</h5>

        <form>
          <div className="form_horizontal_group">
            <div className="form_input_group">
              <label>Nom du client*</label>
              <Input
                className="input"
                placeholder="Nom du client"
                value={formData.lastName}
                onChange={(e) => setFormData(prevState => ({...prevState, lastName: e.target.value}))}
              />
              {formErrors.includes("lastName") && (
                <span className="form_input_error_text">Le nom du client est obligatoire.</span>
              )}
            </div>

            <div className="form_input_group">
              <label>Prénom du client</label>
              <Input
                className="input"
                placeholder="Prénom du client"
                value={formData.firstName}
                onChange={(e) => setFormData(prevState => ({...prevState, firstName: e.target.value}))}
              />
            </div>
          </div>

          <div className="form_horizontal_group">
            <div className="form_input_group">
              <label>ID Client</label>
              <Input
                className="form_input"
                type="number"
                placeholder="ID Client"
                value={formData.clientErpId}
                onChange={(e) => setFormData(prevState => ({...prevState, clientErpId: e.target.value}))}
              />
            </div>

            <div className="form_input_group">
              <label>Groupe Client</label>
             <Select
                className="form_select"
                classNamePrefix="form_select"
                isSearchable
                isClearable
                value={formData.group || null}
                options={CLIENT_GROUP_CRM_FILTER}
                onChange={(option) => setFormData(prevState => ({...prevState, group: option}))}
              />
            </div>
          </div>

          <div className="form_input_group">
            <label>Adresse E-mail*</label>
            <Input
              className="form_input"
              type="email"
              placeholder="Adresse E-mail"
              value={formData.email}
              onChange={(e) => setFormData(prevState => ({...prevState, email: e.target.value}))}
            />
          </div>

          <div className="form_input_group">
            <label>Numéro de téléphone</label>
            <Input
              className="form_input"
              placeholder="Numéro de téléphone"
              value={formData.phoneNumber}
              onChange={(e) => setFormData(prevState => ({...prevState, phoneNumber: e.target.value}))}
            />
          </div>

          <div className="form_horizontal_group">
            <div className="form_input_group">
              <label>Chiffre d'affaire</label>
              <Input
                className="form_input"
                type="number"
                placeholder="Chiffre d'affaire"
                value={formData.revenue}
                onChange={(e) => setFormData(prevState => ({...prevState, revenue: e.target.value}))}
              />
            </div>

            <div className="form_input_group">
              <label>Canal*</label>
              <CreatableSelect
                className="form_select"
                classNamePrefix="form_select"
                closeMenuOnSelect
                placeholder="Sélect."
                options={channelOptions}
                value={formData.channel}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '30px',
                    height: '30px',
                    fontSize: '12px',
                  }),
                  valueContainer: (provided) => ({
                    ...provided,
                    height: '30px',
                    padding: '0 6px',
                  }),
                  input: (provided) => ({
                    ...provided,
                    margin: '0px',
                  }),
                  indicatorSeparator: () => ({
                    display: 'none',
                  }),
                  indicatorsContainer: (provided) => ({
                    ...provided,
                    height: '30px',
                  }),
                  option: (provided) => ({
                    ...provided,
                    fontSize: '12px',
                    padding: '6px 10px',
                  }),
                }}
                onChange={(newValue) => {
                  setFormData(prevState => ({...prevState, channel: newValue}));
                }}
                isSearchable
              />
              {formErrors.includes("channel") && (
                <span className="form_input_error_text">Choisissez un canal d’entrée pour le client.</span>
              )}
            </div>
          </div>

          <div className="form_input_group">
            <label>Date d'échéance</label>
            <DatePicker
              dropdownClassName="prospect_datepicker_dropdown"
              className="prospect_datepicker_input"
              format="DD/MM/YYYY"
              value={
                formData.dueDate
                  ? moment(formData.dueDate, "DD/MM/YYYY")
                  : null
              }
              locale="fr"
              allowClear={false}
              placeholder="Séléct."
              popupClassName="prospect_datepicker_popup"
              onSelect={(date) => {
                if (moment(date).isValid()) {
                  setFormData(prevState => ({...prevState, dueDate: date }));
                }
              }}
            />
          </div>

          <div className="form_input_group">
            <label>Remarque</label>
            <TextArea
              className="form_textarea"
              rows={3}
              placeholder="Remarque"
              value={formData.observation}
              onChange={(e) => setFormData(prevState => ({...prevState, observation: e.target.value}))}
            />
          </div>

          <div className="form_btns">
            <Button
              type="ghost"
              onClick={() => {
                setIsOpen(false);
                resetForm();
              }}
            >
              Annuler
            </Button>
            <Button
              type="primary"
              onClick={() => { if (!isSaving) handleSave() }}
              className={classNames({
                "form_btn_success": true,
                "form_btn_success_disabled": isSaving
              })}
            >
              {isSaving && (<LoadingIcon color="white" size={20} />)}
              {clientData === null ? 'Ajouter' : 'Modifier'}
            </Button>
          </div>

        </form>
      </div>
    </Dialog>
  )
}
